import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';

import type { Entity } from './entities';

/**
 * Fires when user clicks out of non-empty field
 */
export interface InputFill {
  /**
   * name that identifies the field
   */
  fieldName: string;
  /**
   * content of input fields that accept strings
   */
  strInput?: string | null;
  /**
   * content of input fields that accept numbers
   */
  numInput?: number | null;
  /**
   * content of input fields that accept boolean values
   */
  boolInput?: boolean | null;
  /**
   * validation errors
   */
  fieldErrors?: string[] | null;
  /**
   * suggested values
   */
  fieldSuggestions?: string[] | null;
  /**
   * the type of the field
   */
  fieldType:
    | 'checkbox'
    | 'date'
    | 'dropdown'
    | 'hidden'
    | 'number'
    | 'password'
    | 'radio'
    | 'range'
    | 'switch'
    | 'tel'
    | 'text'
    | 'textarea';
  /**
   * indicates if the field was auto filled
   */
  isAutoFilled: boolean;
}

export const inputFill = (data: InputFill, context?: Entity[]) =>
  trackSelfDescribingEvent({
    event: { schema: 'iglu:com.starsgroup/input_fill/jsonschema/3-0-0', data },
    context
  });
